import apiClient from "./client";

export const listAdmins = () => apiClient.get("/admins");

export const createAdmin = (payload) =>
  apiClient.post("/signup-admin", payload);

export const updateAdminRole = (id, role) =>
  apiClient.patch(`/admin/${id}/role`, { role });

export const deleteAdmin = (id) => apiClient.delete(`/admin/${id}`);
